
import messages from '../translations';

let idiomas = new Object();

for(let lang in messages){
	idiomas[lang] = messages[lang].enlaces;
}

export function langdetector() {

	var allowed = ['es', 'la', 'en', 'cat'];

	// Preferir el idioma ya guardado (p. ej. tras login o selector), no machacarlo por la URL
	if (typeof window !== 'undefined' && window.localStorage) {
		var stored = window.localStorage.getItem('language');
		if (stored && allowed.indexOf(stored) !== -1) {
			return stored;
		}
	}

	var langSelected = 'es';
	var path = location.pathname;

	if(path == "/" || path == "/404"){

		var localStorageLang = window.localStorage.getItem('language');

		if (!!!localStorageLang){
			langSelected = navigator.language.substring(0, 2);
		}else{
			(!Object.keys(idiomas).some(function(i) { return i == localStorageLang; })) ? langSelected = "es" : langSelected = localStorageLang;
		}

	}else{

		path = '/'+path.split("/")[1];

		// Misma ruta en varios idiomas (p. ej. /documentacion): antes ganaba el último en el bucle (a menudo cat)
		for(var lang in idiomas){

			var array = Object.entries(idiomas[lang]);

			if (array.some(function(e) { return e[1] == path; })) {
				langSelected = lang;
				break;
			}

		}

	}

	return allowed.indexOf(langSelected) !== -1 ? langSelected : 'es';

}


// WEBPACK FOOTER //
// ./src/langdetector/index.js